import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { GlobalSearchItemPersistedModel } from "./models";
import { isNotNil } from "client/Misc/utils";
import { logNever } from "client_legacy/ndaw/errors";

export type ValidGlobalSearchItemPersistedModel<TKind extends GlobalSearchResultItemKind = GlobalSearchResultItemKind> =
	TKind extends GlobalSearchResultItemKind.Announcement ? KindDataMap<TKind, "announcement"> :
	TKind extends GlobalSearchResultItemKind.App ? KindDataMap<TKind, "app"> :
	TKind extends GlobalSearchResultItemKind.Community ? KindDataMap<TKind, "community"> :
	TKind extends GlobalSearchResultItemKind.CommunityPost ? KindDataMap<TKind, "communityPost"> :
	TKind extends GlobalSearchResultItemKind.Contact ? KindDataMap<TKind, "contact"> :
	TKind extends GlobalSearchResultItemKind.Document ? KindDataMap<TKind, "document"> :
	TKind extends GlobalSearchResultItemKind.EgnyteItem ? KindDataMap<TKind, "egnyteItem"> :
	TKind extends GlobalSearchResultItemKind.Email ? KindDataMap<TKind, "email"> :
	TKind extends GlobalSearchResultItemKind.Event ? KindDataMap<TKind, "event"> :
	TKind extends GlobalSearchResultItemKind.IntegrationFlow ? KindDataMap<TKind, "integrationFlow"> :
	TKind extends GlobalSearchResultItemKind.KnowledgeItems ? KindDataMap<TKind, "knowledgeItem"> :
	never;

export function isValid(model: GlobalSearchItemPersistedModel): model is ValidGlobalSearchItemPersistedModel {
	switch (model.kind) {
		case GlobalSearchResultItemKind.Announcement:
			return isNotNil(model.announcement);
		case GlobalSearchResultItemKind.App:
			return isNotNil(model.app);
		case GlobalSearchResultItemKind.Community:
			return isNotNil(model.community);
		case GlobalSearchResultItemKind.CommunityPost:
			return isNotNil(model.communityPost);
		case GlobalSearchResultItemKind.Contact:
			return isNotNil(model.contact);
		case GlobalSearchResultItemKind.Document:
			return isNotNil(model.document);
		case GlobalSearchResultItemKind.EgnyteItem:
			return isNotNil(model.egnyteItem);
		case GlobalSearchResultItemKind.Email:
			return isNotNil(model.email);
		case GlobalSearchResultItemKind.Event:
			return isNotNil(model.event);
		case GlobalSearchResultItemKind.IntegrationFlow:
			return isNotNil(model.integrationFlow);
		case GlobalSearchResultItemKind.KnowledgeItems:
			return isNotNil(model.knowledgeItem);
		default:
			logNever(model.kind);
			return false;
	}
}

type DataProperties = Exclude<
	StringKeyOf<GlobalSearchItemPersistedModel>,
	"kind" | "itemScope"
>;

type KindDataMap<
	TKind extends GlobalSearchResultItemKind,
	TDataProperty extends DataProperties
> = Omit<GlobalSearchItemPersistedModel, "kind" | TDataProperty>
	& {
		kind: TKind;
	}
	& {
		[P in TDataProperty]-?: Exclude<GlobalSearchItemPersistedModel[TDataProperty], undefined>;
	};
